import { Injectable } from '@angular/core';
export class ConfirmationConstantService {
constructor() {}
public validations: any = {
    compOrBuilding: {
      required: 'Nama Gedung wajib diisi',
      maxlength: 'Nama Gedung Maksimal 50 Karakter',
      alphaNumeric: 'Nama Gedung hanya boleh alphanumerik',
      noSpace: 'Nama Gedung tidak diboleh diawali dengan spasi',
      noLeadingMin: 'Nama Gedung tidak diboleh diawali dengan -',
    },
    buildingNumber: {
      required: 'Nomor Gedung wajib diisi',
      maxlength: 'Nomor Gedung maksimal 5 digit',
      alphaNumeric: 'Nomor Gedung hanya boleh alphanumerik',
    },
    flatNumber: {
      required: 'Nomor Blok/Kavling wajib diisi',
      maxlength: 'Nomor Blok/Kavling maksimal 5 digit',
      alphaNumeric: 'Nomor Blok/Kavling hanya boleh alphanumerik',
    },
    buildingType: {
      requiredSelect: 'Tipe Bangunan wajib dipilih',
    },
    street: {
      required: 'Nama Jalan wajib diisi',
      noSpace: 'Nama Jalan tidak diboleh diawali dengan spasi',
      maxlength: 'Nama Jalan maksimal 100 karakter',
      minlength: 'Nama jalan minimal 2 karakter',
    },
    rt: {
      required: 'RT wajib diisi',
      numerical: 'RT hanya boleh diisi angka',
      maxlength: 'RT maksimal 3 karakter',
    },
    rw: {
      required: 'RW wajib diisi',
      numerical: 'RW hanya boleh diisi angka',
      maxlength: 'RW maksimal 3 karakter',
    },
    province: {
      requiredSelect: 'Provinsi wajib dipilih',
    },
    city: {
      requiredSelect: 'Kota wajib dipilih',
    },
    district: {
      requiredSelect: 'Kecamatan wajib dipilih',
    },
    village: {
      requiredSelect: 'Kelurahan wajib dipilih',
    },
    postalCode: {
      requiredSelect: 'Kode Pos wajib dipilih',
    },
    officePhoneNumber: {
      numerical: 'Nomor Telepon hanya boleh diisi angka',
      maxlength: 'Nomor Telepon maksimum 13 karakter',
      minlength: 'Nomor Telepon minimum 9 karakter',
      required: 'Nomor Telepon Tempat Kerja wajib diisi',
    },
    jobRole: {
      required: 'Jabatan Pekerjaan wajib diisi',
      maxlength: 'Jabatan Pekerjaan Maksimal 100 Karakter',
      alphaNumeric: 'Jabatan Pekerjaan hanya boleh alphanumerik',
      noSpace: 'Jabatan Pekerjaan tidak boleh diawali spasi',
      noLeadingMin: 'Jabatan Pekerjaan tidak boleh diawali -',
    },
    bankName: {
      required: 'Nama Bank wajib diisi',
      noMatchValue: 'Nama Bank tidak terdaftar',
    },
    accountNumber: {
      required: 'Nomor Rekening wajib diisi',
      requiredSelect: 'Nomor rekening tidak boleh diisi nol',
      numerical: 'Nomor Rekening hanya boleh diisi angka',
      maxlength: 'Nomor Rekening maksimum 30 karakter',
      minlength: 'Nomor Rekening minimal 5 karakter',
    },
    accountType: {
      required: 'Jenis Bank wajib diisi',
    },
    pinPicture: {
      pinPicture: 'Foto KTP wajib diisi',
    },
  };
public buildingType = [
    {
      name: 'Rumah',
      value: 'Rumah',
    },
    {
      name: 'Apartemen',
      value: 'Apartemen',
    },
    {
      name: 'Kantor',
      value: 'Kantor',
    },
  ];
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ConfirmationConstantService_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationConstantService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationConstantService.ctorParameters;
/** @type {?} */
ConfirmationConstantService.prototype.validations;
/** @type {?} */
ConfirmationConstantService.prototype.buildingType;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
